<template>
  <tr>
    <td :style="!season.track_hole_scores ? undefined : 'display: none'">
      <v-btn flat @click="handleRemove()" :small="true" fab
        ><v-icon>close</v-icon></v-btn
      >
    </td>
    <td>
      <v-layout row wrap>
        <v-flex
          lg6
          xs12
          v-for="(item, index) in card.players"
          v-bind:key="item.player_id"
        >
          <v-layout row>
            <v-flex xs7>
              <v-combobox
                v-model="item.player"
                :items="players"
                :filter="filterPlayer"
                item-text="name"
                :label="`Player ${index + 1}`"
                :full-width="false"
                :auto-select-first="true"
                dense
              >
                <template v-slot:item="option">
                  <div>
                    {{ option.item.name }}
                    <span class="caption">{{
                      option.item.aliases ? option.item.aliases.join(",") : ""
                    }}</span>
                  </div>
                </template>
              </v-combobox>
            </v-flex>
            <v-flex xs4>
              <v-select
                v-model="item.division"
                :items="divisions"
                label="Division"
                :auto-select-first="true"
                dense
              ></v-select>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </td>
    <td
      :style="season.track_hole_scores ? undefined : 'display: none'"
      v-for="hole in card.holes"
      v-bind:key="`hole-${index}-${hole.hole}`"
      v-bind:class="getHoleClass(hole)"
      class="text-xs-center"
    >
      <input
        type="number"
        class="hole-score"
        min="1"
        v-model.lazy="hole.score"
        @change="calcTotal(card)"
      />
    </td>
    <td v-if="season.track_hole_scores" class="text-xs-right font-weight-bold">
      {{ `${card.total} (${card.total - courseMetaData.courseTotal})` }}
    </td>
    <td v-if="!season.track_hole_scores" class="text-xs-center">
      <input
        type="number"
        class="hole-score"
        min="1"
        v-model="card.total"
        @change="calcTotal(card)"
      />
    </td>
    <td v-if="!season.track_hole_scores" class="text-xs-right font-weight-bold">
      {{ `${card.total - courseMetaData.courseTotal}` }}
    </td>
    <td class="text-xs-center">
      <v-checkbox v-model="card.winner"></v-checkbox>
    </td>
    <td class="text-xs-center">
      <input type="number" class="hole-score" v-model="card.cashed" min="0" />
    </td>
  </tr>
</template>

<script>
export default {
  name: "WeekEditorRow",
  props: [
    "card",
    "index",
    "courseMetaData",
    "players",
    "divisions",
    "season",
    "onRemove",
  ],
  methods: {
    // TODO: move to directive for reuse in weekly scorecard view
    getHoleClass(hole) {
      const holeMeta = this.courseMetaData.holes.find(
        (hmd) => hmd.hole === hole.hole
      );
      const score = parseInt(hole.score);

      if (score === 1) {
        return "ace";
      }

      const diff = score - holeMeta.par;

      if (diff >= 3) {
        return "triple-bogey";
      }

      if (diff <= -3) {
        return "albatross";
      }

      switch (diff) {
        case -2:
          return "eagle";
        case -1:
          return "birdie";
        case 0:
          return "par";
        case 1:
          return "bogey";
        case 2:
          return "double-bogey";
      }
    },
    calcTotal(card) {
      if (!this.season.track_hole_scores) {
        return;
      }
      card.total = card.holes.reduce(
        (result, hole) => result + parseInt(hole.score),
        0
      );
    },
    filterPlayer(item, queryText) {
      const lower = queryText.toLowerCase();
      return (
        item.name.toLowerCase().indexOf(lower) > -1 ||
        (item.aliases &&
          item.aliases.some((alias) => alias.toLowerCase().indexOf(lower) > -1))
      );
    },
    handleRemove() {
      this.onRemove();
    },
  },
};
</script>

<style scoped></style>
